// TODO: This file belongs in app, not common.

import { DialogType } from '@tableau/widgets';

import { AboutTableauServerDialog } from '~src/spacesPlatform/components/header/AboutTableauServerDialog';

import { ModalInstance, ReactModalService } from '../../commonInfra/dialogs/ReactModalService';
import { HelpService } from '../../commonInfra/services/HelpService';
import { SessionManagementService } from '../../sessionManagement/SessionManagementService';

export class HelpActions {

  constructor(
    private server: SessionManagementService,
  ) {}

  public showAbout() {
    let modalInstance: ModalInstance;

    const dialogProps = {
      dismiss: () => modalInstance && modalInstance.dismiss(),
      version: this.server.sessionServerVersion(),
      podId: this.server.sessionServerPodId()
    };

    modalInstance = ReactModalService.open({
      shouldReturnFocusOnClose: true,
      type: DialogType.NormalWithTitleBar,
      title: AboutTableauServerDialog.Title(),
      dialogContent: AboutTableauServerDialog.Content(dialogProps),
      footerContent: AboutTableauServerDialog.Footer(dialogProps),
      dialogWidth: 450
    });
  }

  public searchHelp(searchTerm: string) {
    HelpService.search(searchTerm);
  }

}
